var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cgqBox"},[_c('div',{staticClass:"cgqBoxTil"},[_vm._v("\n\t\t\t3.6mm·超细插入部 "),_c('span',[_vm._v("*型号：VRL-XQ30")])]),_c('div',{staticClass:"cgqBoxCen"},[_vm._v("\n\t\t\t可畅通无阻地通过狭窄的腔道，降低患者诊疗时的不适感\n\t\t")]),_c('div',{staticClass:"cgqBoxSp"},[_c('img',{attrs:{"src":require("@/assets/product/page6/sp.png")}})])])])
}]

export { render, staticRenderFns }